import { Box } from "@mui/system";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import CancelIcon from "@mui/icons-material/Cancel";
import { DialogContent, DialogContentText, Grid } from "@mui/material";

const DialogCard = (props: any) => {
  const handleClose = () => {
    props.handleCloseDialog();
  };

  return (
    <Box>
      <Dialog
        open={props.open}
        BackdropProps={{ style: { display: "none" } }}
        PaperProps={{
          sx: props.dailogSx
            ? props.dailogSx
            : {
                borderRadius: "20px",
                minWidth: { md: "350px", xs: "297px" },
                backgroundColor: "white",
                color: "black",
                position: "relative",
              },
        }}
      >
        <DialogTitle
          sx={
            props.dialogTitleSx
              ? props.dialogTitleSx
              : {
                  display: "flex",
                  justifyContent: "space-between",
                  fontWeight: "600",
                }
          }
          style={{ height: "auto", lineHeight: "28px", whiteSpace: "pre-line" }}
        >
          <Grid item md={11.5}>
            {props.title}
          </Grid>
          {props.showClose && (
            <Grid item md={0.5}>
              <CancelIcon onClick={handleClose} />
            </Grid>
          )}
        </DialogTitle>
        <DialogContent sx={props.dialogContentSx}>
          <DialogContentText
            className={props.class}
            sx={props.dialogContentTextSx}
          >
            {props.contentText}
          </DialogContentText>
          {props.children}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default DialogCard;
